






































import Vue from 'vue';
import { mapGetters } from 'vuex';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import CreateProductModal from '@/web/components/products/CreateProductModal.vue';
import MediaFormModal from '@/web/components/media-library/MediaFormModal.vue';
import StepCard from '@/web/components/quick-start-guide/StepCard.vue';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';

export default Vue.extend({
  name: 'QuickStartGuide',
  mixins: [TeacherPermissionsMixin],
  components: {
    TopNav,
    NavItem,
    StepCard,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', ['teacher']),
    hasSocialMedia() {
      return Boolean(
        this.teacher.facebook_group ||
          this.teacher.facebook_page ||
          this.teacher.instagram ||
          this.teacher.twitter ||
          this.teacher.youtube_channel ||
          this.teacher.linkedin_page ||
          this.teacher.web_link ||
          this.teacher.tiktok_link
      );
    },
    steps() {
      return [
        {
          icon: '/assets/images/sitting_on_beanbag.svg',
          topText: this.$t('QUICKSTART.LABEL.MAKE_IT_YOURS'),
          bottomText: this.$t('QUICKSTART.LABEL.BRANDING'),
          isActive: this.teacher.site_appearance,
          linkTo: '/settings/branding',
        },
        {
          icon: '/assets/images/in_front_of_computer_desk.svg',
          topText: this.$t('QUICKSTART.LABEL.SETUP_SHOP'),
          bottomText: this.$t('QUICKSTART.LABEL.PRODUCT'),
          isActive: this.teacher.first_product,
          linkTo: '/products/my-products',
        },
        {
          icon: '/assets/images/in_front_of_computer_desk.svg',
          topText: this.$t('QUICKSTART.LABEL.EARN_MONEY'),
          bottomText: this.$t('QUICKSTART.LABEL.PAYMENTS'),
          isActive: this.teacher.payments_accounts,
          linkTo: '/settings/account',
        },
        {
          icon: '/assets/images/in_front_of_computer_desk.svg',
          topText: this.$t('QUICKSTART.LABEL.CONNECT'),
          bottomText: this.$t('QUICKSTART.LABEL.SOCIAL_MEDIA'),
          isActive: this.hasSocialMedia,
          linkTo: '/settings/branding',
        },
      ];
    },
  },
  methods: {
    openUploadFilesModal() {
      this.$modal.show(
        MediaFormModal,
        {
          videoUploadAllowed: this.videoUploadAllowed,
        },
        { clickToClose: false }
      );
    },
    openAddProductModal() {
      this.$modal.show(CreateProductModal);
    },
  },
});
